module.exports = __webpack_public_path__ + "static/media/996743.fcb99533.png";